export default "__VITE_ASSET__CELn5MYJ__"